// extracted by mini-css-extract-plugin
module.exports = {"userName":"MainNavbar_userName__3Gk4D"};